<template>
  <div class="guest">
    <div class="row align-items-center">
      <div class="col-2">
        <div class="guest__icon">
          <iconChild
            class="icon icon--child"
            v-if="guest.person_type === 'child'"
          ></iconChild>
          <iconFemale
            class="icon"
            v-if="guest.person_type === 'adult'"
          ></iconFemale>
          <iconMale
            class="icon"
            v-if="guest.person_type === 'adult'"
          ></iconMale>
          <iconDog class="icon" v-if="guest.person_type === 'pet'"></iconDog>
        </div>
      </div>
      <div class="col-10 col-md-6">
        <div class="guest__meta">
          <h3 class="guest__headline">{{ guest.name }}</h3>
          <div class="guest__copy" v-html="guest.description"></div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="guest__count">
          <CiCounter
            :value="amount"
            :canIncrease="amount < max"
            :canDecrease="amount > min"
            @update:value="onGuestChanged"
          >
          </CiCounter>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CiCounter } from '@/components'
import iconChild from '@/assets/icons/child.svg'
import iconDog from '@/assets/icons/dog.svg'
import iconFemale from '@/assets/icons/female.svg'
import iconMale from '@/assets/icons/male.svg'

export default {
  name: 'CiGuest',
  components: {
    CiCounter,
    iconChild,
    iconDog,
    iconFemale,
    iconMale,
  },
  props: {
    amount: {
      type: Number,
      default: 0,
    },
    guest: {
      type: Object,
      required: true,
    },
    min: {
      type: Number,
      default() {
        return 0
      },
    },
    max: {
      type: Number,
      default() {
        return Infinity
      },
    },
  },
  methods: {
    onGuestChanged(amount) {
      if (amount >= this.max) amount = this.max
      if (amount <= this.min) amount = this.min
      this.$emit('update:amount', { amount, person: this.guest })
    },
  },
}
</script>
<style lang="scss">
.guest .guest__copy * {
  margin: 0;
  padding: 0;
}
</style>
<style lang="scss" scoped>
.guest {
  padding: 0;
  transition: background-color 0.6s ease;

  @include media-breakpoint-up(md) {
    justify-content: center;
    padding: 20px;
  }

  .no-touch &:hover {
    background: none;
    transition: background-color 0.6s ease;

    @include media-breakpoint-up(md) {
      background-color: rgba(155, 155, 155, 0.05);
    }
  }
}

.guest__meta {
  .guest__headline {
    margin: 0;
    padding: 0;
  }

  .guest__copy {
    margin: 0;
    padding: 0;
  }
}

.guest__icon {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  max-height: 50px;

  .icon {
    height: 35px;

    &.icon--child {
      height: 28px;
    }
  }
}

.guest__count {
  display: flex;
  margin: 20px 0 0;
  justify-content: flex-end;

  @include media-breakpoint-up(md) {
    justify-content: center;
    margin: 0;
  }
}
</style>
